// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EDeinQzfS2N2rVW_Z1GP {
  height: 18vmin;
  width: 18vmin;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--bg);
  color: var(--tan-1);
  font-size: 2.7vmin;
  border: 0.6vmin solid var(--tan-1);
}
.EDeinQzfS2N2rVW_Z1GP a {
  position: absolute;
  opacity: 0;
  transition: opacity 0.4s ease;
  color: var(--yellow-1);
  font-weight: 400;
  margin: 0;
}
.EDeinQzfS2N2rVW_Z1GP:hover a {
  opacity: 1;
  color: var(--yellow-1);
  font-weight: 500;
  font-size: 3.35vmin;
}
.EDeinQzfS2N2rVW_Z1GP img {
  max-width: 100%;
  max-height: 100%;
  border-radius: 50%;
  transition: opacity 0.4 ease;
}
.EDeinQzfS2N2rVW_Z1GP:hover img {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.module.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;AACJ;AACI;EACI,kBAAA;EACA,UAAA;EACA,6BAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AACR;AAEI;EACI,UAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,4BAAA;AADR;AAII;EACI,UAAA;AAFR","sourcesContent":[".Logo {\n    height: 18vmin;\n    width: 18vmin;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background-color: var(--bg);\n    color: var(--tan-1);\n    font-size: 2.7vmin;\n    border: .6vmin solid var(--tan-1);\n\n    a {\n        position: absolute;\n        opacity: 0;\n        transition: opacity 0.4s ease;\n        color: var(--yellow-1);\n        font-weight: 400;\n        margin: 0;\n    }\n    \n    &:hover a {\n        opacity: 1;\n        color: var(--yellow-1);\n        font-weight: 500;\n        font-size: 3.35vmin;\n    }\n\n    img {\n        max-width: 100%;\n        max-height: 100%;\n        border-radius: 50%;\n        transition: opacity 0.4 ease;\n    }\n\n    &:hover img {\n        opacity: 0;\n    }\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Logo": `EDeinQzfS2N2rVW_Z1GP`
};
export default ___CSS_LOADER_EXPORT___;
